export const WIDGET_TYPE = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
  UNKNOWN: 'unknown'
} as const;
export type WidgetType = (typeof WIDGET_TYPE)[keyof typeof WIDGET_TYPE];

export const COMMENT_MODE = {
  DEFAULT: 'default',
  EDIT: 'edit'
} as const;
export type CommentMode = (typeof COMMENT_MODE)[keyof typeof COMMENT_MODE];
export const READED = 'readed';
